/* eslint-disable i18next/no-literal-string */

/* istanbul ignore file */
import i18n, {Resource} from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import {initReactI18next} from 'react-i18next';

import {getLanguages} from '../components/templates/BasePage/utils';

import {languageFiles} from './gen/backend';

/**
 * Make sure we're matching the language code in the browser to the one in our settings,
 * the browser/django likes to change casing of the language code
 */
const languages = getLanguages().map(language => language[0]);
let currentLanguage = languages.find(item => item.toLowerCase() === document.documentElement.lang.toLowerCase());
if (!currentLanguage) {
    currentLanguage = 'en';
}

const importFunc = languageFiles[currentLanguage];
const strings = importFunc ? ((await importFunc()) as {default: Resource}) : {default: {}};

void i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        ns: Object.keys(strings.default),
        interpolation: {
            escapeValue: false,
        },
        detection: {
            order: ['htmlTag'],
            excludeCacheFor: ['en-GB'],
        },
        returnEmptyString: false,
        resources: {[currentLanguage]: strings.default},
    });

export default i18n;

/* eslint-enable i18next/no-literal-string */
